import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'
import {
  InputGroup,
  FormControl,
  Button,
  DropdownButton,
  Dropdown,
} from 'react-bootstrap'

const Search = props => {
  const [search, setSearch] = useState('')
  const [recommendedList, setRecommendedList] = useState([])
  const [trendingList, setTrendingList] = useState([])
  const [lang, setLang] = useState('ja')

  const langList = ['ko', 'en', 'ja', 'pt', 'es', 'vi', 'zh-TW']

  useEffect(() => {
    getSearchList()
  }, [lang])

  const keyEvent = e => {
    if (e.key === 'Enter') {
      handleSubmit(e)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    await insertRecommended(search)
  }

  const getSearchList = async () => {
    await axios
      .get(`/new/webAdmin/v2/assistant/search?lang=${lang}`, {
        headers: {
          token: sessionStorage.getItem('token'),
          apikey: 'b7d85e59d3a6bda31bc287b85ac2a83f',
        },
      })
      .then(({ data }) => {
        console.log(data.result)
        setSearch('')
        setRecommendedList(data.result.recommend)
        setTrendingList(data.result.trending)
      })
  }

  const insertRecommended = async search => {
    await axios
      .post(
        `/new/webAdmin/v2/assistant/search/recommend`,
        { search, lang },
        {
          headers: {
            token: sessionStorage.getItem('token'),
            apikey: 'b7d85e59d3a6bda31bc287b85ac2a83f',
          },
        }
      )
      .then(() => {
        alert('success')
        getSearchList()
      })
  }

  const deleteRecommended = async seq => {
    await axios
      .delete(`/new/webAdmin/v2/assistant/search/recommend/${seq}`, {
        headers: {
          token: sessionStorage.getItem('token'),
          apikey: 'b7d85e59d3a6bda31bc287b85ac2a83f',
        },
      })
      .then(() => {
        alert('deleted')
        getSearchList()
      })
  }

  return (
    <div
      className="content-wrapper"
      style={{ minHeight: '100%', marginLeft: '0' }}
    >
      <section className="content-header">
        <h1>Assistant Search</h1>
        <ol className="breadcrumb">
          <li>
            <i className="fa fa-dashboard"></i>Stipop
          </li>
          <li className="active">Search</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          {/* <!-- Left col --> */}
          <section className="col-lg-12 connectedSortable">
            {/* <!-- Custom tabs (Charts with tabs)--> */}
            <div className="box box-info" style={{ padding: '10px' }}>
              {/* <!-- /.box-header --> */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <DropdownButton
                  variant="dark"
                  id="commit-status-dropdown"
                  title={lang}
                >
                  {langList.map((data, index) => {
                    return (
                      <Dropdown.Item key={index} onClick={() => setLang(data)}>
                        {data}
                      </Dropdown.Item>
                    )
                  })}
                </DropdownButton>
                <b>Recommended</b>
              </div>
              <div className="box-body">
                <InputGroup onSubmit={e => handleSubmit(e, 'character')}>
                  <FormControl
                    type="text"
                    value={search}
                    placeholder="Search"
                    onChange={e => setSearch(e.target.value)}
                    onKeyPress={e => keyEvent(e, 'character')}
                  />
                  <Button
                    variant="primary"
                    onClick={e => handleSubmit(e, 'character')}
                    style={{ height: '38px' }}
                  >
                    <i className="fa fa-plus" />
                  </Button>
                </InputGroup>
                <div style={{ marginTop: 20 }}>
                  <FilterWrapper>
                    {recommendedList.length > 0 &&
                      recommendedList.map((r, i) => (
                        <FilterItem
                          key={i}
                          onClick={() => deleteRecommended(r.seq)}
                        >
                          {r.search}
                        </FilterItem>
                      ))}
                  </FilterWrapper>
                </div>
              </div>
            </div>
          </section>
          <section className="col-lg-12 connectedSortable">
            <div className="box box-info" style={{ padding: '0 10px' }}>
              <div className="box-body">
                <Table>
                  <tbody>
                    <tr>
                      <Field>Keyword</Field>
                      <Field>Lang</Field>
                      <Field>Count</Field>
                    </tr>
                    {trendingList.length > 0 &&
                      trendingList.map((t, i) => (
                        <tr key={i}>
                          <td>{t.search}</td>
                          <td>{t.lang}</td>
                          <td>{t.cnt}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  )
}

export default Search

const FilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px 8px;
`

const FilterItem = styled.div`
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #dc143c;
    color: #fff;
  }
`

const Table = styled.table`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
`

const Field = styled.th`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  text-align: left;
`

const Data = styled.td`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  display: table-cell;
`
